document.addEventListener('DOMContentLoaded', function () {
  var filtersPanel = document.getElementById('CollectionFilters');
  var filterForm = document.getElementById('CollectionFilterForm');
  var openBtns = document.querySelectorAll('[data-filters-open]');
  var closeBtns = document.querySelectorAll('[data-filters-close]');
  var overlay = document.querySelector('.collection-page__overlay');
  var applyBtn = document.querySelector('[data-apply-filters]');

  function openFilters() {
    if (filtersPanel) filtersPanel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    if (filtersPanel) filtersPanel.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  openBtns.forEach(function (btn) {
    btn.addEventListener('click', openFilters);
  });

  closeBtns.forEach(function (btn) {
    btn.addEventListener('click', closeFilters);
  });

  // Collapsible filter groups
  var toggles = document.querySelectorAll('[data-filter-toggle]');
  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var group = toggle.closest('.collection-page__filter-group');
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      if (group) group.setAttribute('data-collapsed', String(expanded));
    });
  });

  // Build the filter URL manually from the form's current field state,
  // rather than trusting native GET form submission (which was misbehaving
  // with the price number inputs).
  function applyFilters() {
    if (!filterForm) return;

    var params = new URLSearchParams(window.location.search);

    // Remove all existing filter/price params first so unchecked boxes
    // and cleared price fields actually get removed, not just left stale.
    Array.from(params.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0) {
        params.delete(key);
      }
    });

    var checkboxes = filterForm.querySelectorAll('input[type="checkbox"][data-filter-input]');
    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        params.append(checkbox.name, checkbox.value);
      }
    });

    var priceInputs = filterForm.querySelectorAll('input[type="number"]');
    priceInputs.forEach(function (input) {
      var value = input.value.trim();
      if (value !== '') {
        params.set(input.name, value);
      }
    });

    // Reset to page 1 whenever filters change
    params.delete('page');

    window.location.search = params.toString();
  }

  // Desktop: auto-apply the moment a checkbox changes
  var checkboxInputs = document.querySelectorAll('[data-filter-input]');
  checkboxInputs.forEach(function (checkbox) {
    checkbox.addEventListener('change', applyFilters);
  });

  // Price inputs: populate from the RAW URL ourselves (not from Shopify's
  // echoed filter.min_value.value), since that echo was the source of the
  // ×10 compounding bug. Then apply on Enter, not on every keystroke.
  var priceFields = document.querySelectorAll('[data-price-input]');
  var currentParams = new URLSearchParams(window.location.search);

  priceFields.forEach(function (input) {
    var rawValue = currentParams.get(input.name);
    if (rawValue !== null) {
      input.value = rawValue;
    }

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        applyFilters();
      }
    });
  });

  // Mobile: explicit Apply button in the drawer
  if (applyBtn) {
    applyBtn.addEventListener('click', function (event) {
      event.preventDefault();
      applyFilters();
    });
  }

  // Belt-and-suspenders: if the form somehow submits natively, handle it ourselves
  if (filterForm) {
    filterForm.addEventListener('submit', function (event) {
      event.preventDefault();
      applyFilters();
    });
  }

  // Grid column view toggle
  var viewButtons = document.querySelectorAll('[data-view-columns]');
  var grid = document.querySelector('[data-collection-grid]');

  viewButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      viewButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (grid) {
        grid.style.setProperty('--active-columns', btn.getAttribute('data-view-columns'));
      }
    });
  });

  // Sort dropdown: preserve existing filter params, only change sort_by
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      window.location.search = params.toString();
    });
  }
});